import React from "react";
import { FlowId } from "@msidentity/sisu/constants/routing-constants";
import { ChallengeViewRendererFabric } from "@msidentity/SISU/views/challenge/fabric/challenge-view-renderer-fabric";
import { useChallengeViewPropertiesFabric } from "@msidentity/SISU/views/challenge/fabric/hooks/use-challenge-view-properties-fabric";
import UsernameRecoveryConfig from "../../../username-recovery-config";
import { useUsernameRecoveryChallenge } from "../model/hooks/use-challenge";

/**
 * Challenge for the Username Recovery flow
 * @returns instance of the component
 */
export const UsernameRecoveryChallengeViewFabric: React.FC =
  function UsernameRecoveryChallengeViewFabric() {
    const validateChallenge = useUsernameRecoveryChallenge(UsernameRecoveryConfig.instance);
    const challengeViewProperties = useChallengeViewPropertiesFabric(validateChallenge);
    challengeViewProperties.activateViewOptions = {
      showIdentityBanner: false,
    };

    return (
      <ChallengeViewRendererFabric
        challengeViewProps={challengeViewProperties}
        flowId={FlowId.UsernameRecovery}
      />
    );
  };
